<template>
  <div>
    <CreateAdvanceModeSimilar
      ref="refAdvanceModeSimilarDialog"
      v-model:visible="renderData.advanceModeSimilarDialogVisible"
      :data="renderData.advanceModeData"
      v-if="
        renderData.advanceModeSimilarDialogVisible &&
        renderData.createSimilarType === 'hard'
      "
      @close="closeAdvanceModeSimilarDialog"
      @goCreateResult="goCreateResult"
    ></CreateAdvanceModeSimilar>
    <CreateEasyModeSimilar
      v-model:visible="renderData.easyModeSimilarDialogVisible"
      :data="renderData.easyModeData"
      @goCreateResult="goCreateResult"
      @close="closeEasyModeSimilarDialog"
      v-if="
        renderData.easyModeSimilarDialogVisible &&
        renderData.createSimilarType === 'easy'
      "
    ></CreateEasyModeSimilar>

    <createBgmAdvanceModeSimlar
      ref="refBgmAdvanceModeSimilarDialog"
      v-model:visible="renderData.bgmAdvanceModeSimilarDialogVisible"
      :data="renderData.bgmAdvanceModeData"
      v-if="
        renderData.bgmAdvanceModeSimilarDialogVisible &&
        renderData.createSimilarType === 'hard'
      "
      @close="closeBgmAdvanceModeSimilarDialog"
      @goCreateResult="goBgmCreateResult"
    ></createBgmAdvanceModeSimlar>

    <createBgmEasyModeSimilar
      v-model:visible="renderData.bgmEasyModeSimilarDialogVisible"
      :data="renderData.bgmEasyModeData"
      @goCreateResult="goBgmCreateResult"
      @close="closeBgmEasyModeSimilarDialog"
      v-if="
        renderData.bgmEasyModeSimilarDialogVisible &&
        renderData.createSimilarType === 'easy'
      "
    ></createBgmEasyModeSimilar>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import tools from "@/utils/tools.js";
import message from "@/components/functionCallComponent/message.jsx";

import CreateEasyModeSimilar from "./createEasyModeSimilar.vue";
import CreateAdvanceModeSimilar from "./createAdvanceModeSimilar.vue";
import createBgmAdvanceModeSimlar from "./createBgmAdvanceModeSimilar.vue";
import createBgmEasyModeSimilar from "./createBgmEasyModeSimilar.vue";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";
import useMuseDataStore from "@/store/create/museDataStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js";

import feedListApi from "@/api/api/feedListApi.js";
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js";
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const draftDataStore = useDraftDataStore();
const museDataStore = useMuseDataStore();
const modelDataStore = useModelDataStore();

const Router = useRouter();
const route = useRoute();

const props = defineProps({
  source: {
    type: String,
    default: "",
  },
  song_id: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["songHasDeleted"]);

const refAdvanceModeSimilarDialog = ref(null);
const renderData = reactive({
  curSimilarSongId: "",
  easyModeSimilarDialogVisible: false,
  advanceModeSimilarDialogVisible: false,
  bgmAdvanceModeSimilarDialogVisible: false,
  bgmEasyModeSimilarDialogVisible: false,
  createSimilarType: "hard",
  easyModeData: {},
  advanceModeData: {},
  bgmAdvanceModeData: {},
  bgmEasyModeData: {},
});

const getSimilarEditData = () => {
  const closeMsg = message.loading({
    content: $$t("create.get_similar_dong_data"),
  });
  return new Promise((resolve, reject) => {
    feedListApi
      .getSimilarSongEditData({
        song_id: renderData.curSimilarSongId,
      })
      .then((res) => {
        closeMsg.clear();
        if (res.code == 200) {
          resolve(res.data);
        } else if (res.code == 6332) {
          emits("songHasDeleted");
        } else {
          message.error({
            position: "top",
            content: $$t("create.get_similar_dong_data_failed"),
          });
          reject();
        }
      })
      .catch((err) => {
        closeMsg.clear();
        message.error({
          position: "top",
          content: $$t("create.get_similar_dong_data_failed"),
        });
        reject();
      });
  });
};

const goCreateResult = () => {
  createLayoutStore.toggleCreateEditOpenState(false);
  if (renderData.createSimilarType == "hard") {
    renderData.advanceModeSimilarDialogVisible = false;
    draftDataStore.restoreCacheAdvanceData();
  } else {
    renderData.easyModeSimilarDialogVisible = false;
  }
  Router.push({
    name: "create",
  });
};

const goBgmCreateResult = () => {
  createLayoutStore.toggleBgmCreateEditOpenState(false);
  if (renderData.createSimilarType == "hard") {
    renderData.bgmAdvanceModeSimilarDialogVisible = false;
    draftDataStore.restoreBgmCacheAdvanceData();
  } else {
    renderData.bgmEasyModeSimilarDialogVisible = false;
  }
  Router.push({
    name: "instrumental",
  });
};

const initSimilar = async (song) => {
  renderData.curSimilarSongId = song.song_id;
  if (
    await userDataStore.checkLoginStatus(
      {
        rightType: "", //"generate",
        create_type: "",
        generate: "0",
      },
      (isLogin) => {
        if (isLogin) {
          initSimilar(song);
        }
      }
    )
  ) {
    getSimilarEditData().then((res) => {
      modelDataStore.setSimilarModeModel(res.model);
      if (!res.mode || res.mode == 2) {
        // if (res.motif) {
        //   res.motif = null;
        //   message.info({
        //     positon: "top",
        //     content: $$t("create.current_melody_ideas_unavailable"),
        //   });
        // }
        draftDataStore.tempCacheAdvanceData();
        draftDataStore.setAdvancedModeAllData(res);
        renderData.createSimilarType = "hard";
        renderData.advanceModeSimilarDialogVisible = true;
        renderData.advanceModeData = res;
        globalProperties.logCustomEvent("createsimilar_show", {
          source: props.source,
          mode: "advanced",
        });

        createLayoutStore.setLastSimilarCreateType("similaradvanced");
      } else if (res.mode == 3) {
        draftDataStore.tempBgmCacheAdvanceData();
        draftDataStore.setBgmAdvancedModeAllData(res);
        renderData.createSimilarType = "hard";
        renderData.bgmAdvanceModeSimilarDialogVisible = true;
        renderData.bgmAdvanceModeData = res;
        globalProperties.logCustomEvent("instrumental_createsimilar_show", {
          source: props.source,
          mode: "advanced",
        });
        createLayoutStore.setLastSimilarCreateType("bgmsimilaradvanced");
      } else if (res.mode == 4) {
        createLayoutStore.setLastSimilarCreateType("bgmsimilarbasic");
      } else {
        const advanceModeData = {
          ...res,
          prompt: res.prompt,
        };
        draftDataStore.tempCacheAdvanceData();
        draftDataStore.setAdvancedModeAllData(advanceModeData);
        renderData.createSimilarType = "hard";
        renderData.advanceModeSimilarDialogVisible = true;
        renderData.advanceModeData = advanceModeData;
        globalProperties.logCustomEvent("createsimilar_show", {
          source: props.source,
          mode: "advanced",
        });
        createLayoutStore.setLastSimilarCreateType("similaradvanced");
        // renderData.createSimilarType = "easy";
        // renderData.easyModeSimilarDialogVisible = true;
        // renderData.easyModeData = res;
        // globalProperties.logCustomEvent("createsimilar_show", {
        //   source: props.source,
        //   mode: "basic",
        // });
      }
    });
  }
};

const closeAdvanceModeSimilarDialog = () => {
  if (renderData.advanceModeSimilarDialogVisible) {
    renderData.advanceModeSimilarDialogVisible = false;
    draftDataStore.restoreCacheAdvanceData();
  }
};

const closeBgmAdvanceModeSimilarDialog = () => {
  if (renderData.bgmAdvanceModeSimilarDialogVisible) {
    renderData.bgmAdvanceModeSimilarDialogVisible = false;
    draftDataStore.restoreBgmCacheAdvanceData();
  }
};
const closeBgmEasyModeSimilarDialog = () => {
  if (renderData.bgmEasyModeSimilarDialogVisible) {
    renderData.bgmEasyModeSimilarDialogVisible = false;
    draftDataStore.restoreBgmCreateEasyModeData();
  }
};

const closeEasyModeSimilarDialog = () => {
  if (renderData.easyModeSimilarDialogVisible) {
    renderData.easyModeSimilarDialogVisible = false;
  }
};

Router.beforeEach((to, from, next) => {
  if (to.name == "subscribe") {
    if (renderData.createSimilarType == "hard") {
      if (renderData.advanceModeSimilarDialogVisible) {
        draftDataStore.cacheSimilarAdvanceData(true);
        to.query = Object.assign(to.query ?? {}, {
          from_type: "similar",
          source_route: Router.currentRoute.value.path,
        });
        renderData.advanceModeSimilarDialogVisible = false;
      } else if (renderData.easyModeSimilarDialogVisible) {
        // draftDataStore.cacheCreateEasyModeData(true);
        // to.query = Object.assign(to.query ?? {}, {
        //   from_type: "similar",
        //   source_route: Router.currentRoute.value.path,
        // });
        renderData.easyModeSimilarDialogVisible = false;
      } else {
      }
    } else {
      if (renderData.bgmEasyModeSimilarDialogVisible) {
        // draftDataStore.cacheBgmCreateEasyModeData(true);
        // to.query = Object.assign(to.query ?? {}, {
        //   from_type: "similar",
        //   source_route: Router.currentRoute.value.path,
        // });
        renderData.bgmEasyModeSimilarDialogVisible = false;
      } else if (renderData.bgmAdvanceModeSimilarDialogVisible) {
        // draftDataStore.cacheBgmSimilarAdvanceData(true);
        // to.query = Object.assign(to.query ?? {}, {
        //   from_type: "similar",
        //   source_route: Router.currentRoute.value.path,
        // });
        renderData.advanceModeSimilarDialogVisible = false;
      } else {
      }
    }
  } else {
    if (
      renderData.mountedRouterName != to.name &&
      renderData.routerName == renderData.mountedRouterName
    ) {
      if (renderData.advanceModeSimilarDialogVisible) {
        closeAdvanceModeSimilarDialog();
      } else if (renderData.easyModeSimilarDialogVisible) {
        closeEasyModeSimilarDialog();
      } else if (renderData.bgmEasyModeSimilarDialogVisible) {
        closeBgmEasyModeSimilarDialog();
      } else if (renderData.bgmAdvanceModeSimilarDialogVisible) {
        closeBgmAdvanceModeSimilarDialog();
      } else {
      }
    }
  }
  renderData.routerName = to.name;
  next(); // 放行
});

const init = () => {
  const params = tools.getUrlAllParams();
  if (params.create_type == "similaradvanced") {
    draftDataStore.restoreSimilarCacheAdvanceData(true).then((isOpen) => {
      if (isOpen) {
        renderData.createSimilarType = "hard";
        renderData.advanceModeSimilarDialogVisible = true;
        nextTick().then(() => {
          refAdvanceModeSimilarDialog.value?.update();
        });
      }
    });
  } else if (params.create_type == "bgmsimilaradvanced") {
    draftDataStore.restoreBgmSimilarCacheAdvanceData(true).then((isOpen) => {
      if (isOpen) {
        renderData.createSimilarType = "hard";
        renderData.bgmAdvanceModeSimilarDialogVisible = true;
        nextTick().then(() => {
          refBgmAdvanceModeSimilarDialog.value?.update();
        });
      }
    });
  } else if (params.create_type == "bgmsimilarbasic") {
    draftDataStore.restoreBgmSimilarCacheEasyModeData(true).then((isOpen) => {
      if (isOpen) {
        renderData.createSimilarType = "easy";
        renderData.bgmEasyModeSimilarDialogVisible = true;
      }
    });
  } else {
  }
};

watch(
  () => {
    return userDataStore.userInfo;
  },
  () => {
    if (renderData.advanceModeSimilarDialogVisible) {
      draftDataStore.upDateSimilarCacheAdvanceData().then((isOpen) => {
        nextTick().then(() => {
          refAdvanceModeSimilarDialog.value?.update();
        });
      });
    }
  }
);
// watch(
//   () => Router.currentRoute.value,
//   (val) => {
//     if ((renderData.routerName != Router.currentRoute.value.name)) {
//       renderData.visible = false;
//     }
//   }
// );

onMounted(() => {
  renderData.routerName = Router.currentRoute.value.name;
  renderData.mountedRouterName = Router.currentRoute.value.name;
  init();
});

defineExpose({
  initSimilar: (song) => {
    initSimilar(song);
  },
});
</script>
<style lang="scss"></style>
